import { useState } from 'react';
import { AxiosError } from 'axios';
import { IServiceType } from 'interfaces';
import { reorderServiceTypes } from 'pages/PageServiceTypeList/api';
import useError from 'components/ErrorProvider/useError';

export function useReorderServiceTypes(onSuccess?: () => void) {
  const [loading, setLoading] = useState(false);

  const { addError } = useError();

  const changeServiceTypesOrder = async (serviceTypes: IServiceType[]) => {
    setLoading(true);

    try {
      await reorderServiceTypes(serviceTypes.map((serviceType) => serviceType.serviceTypeId));
      onSuccess?.();
    } catch (error) {
      addError((error as AxiosError).response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  return { loading, changeServiceTypesOrder };
}
